// extracted by mini-css-extract-plugin
export default {"hideTooltip":"v_-z","fadeIn":"w_-z","delay":"x_-z","recommendedSizeTooltip":"y_-z"};